import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative w-full px-4 md:px-6 py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20cozy%20home%20setting%20with%20shoes%20and%20clothing%20neatly%20arranged%2C%20measuring%20tape%20and%20size%20chart%20on%20a%20light%20wooden%20table%2C%20soft%20sunlight%20streaming%20through%20window%2C%20cream%20and%20beige%20tones%2C%20inviting%20atmosphere&width=1600&height=600&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      <div className="relative z-10 max-w-xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">准备好精准选码了吗？</h2>
        <p className="text-white/80 text-sm md:text-base mb-8 leading-relaxed">
          收藏亚洲五码对照指南，购物时随时查阅，从此告别尺码烦恼
        </p>
        <Link
          to="/category/shoes"
          className="inline-block px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
        >
          立即查看对照表
        </Link>
      </div>
    </section>
  );
}